// extracted by mini-css-extract-plugin
module.exports = {"dialog":"DeleteSecurityGroupModal_dialog__1Eb9v"};